import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { TimeEntryState, type TimeEntryType } from "models/TimeEntry";

export type TimeEntryFilters = {
  fromDateIso: string;
  toDateIso: string;
  states: TimeEntryState[] | null;
  types: TimeEntryType[] | null;
  processed: boolean | null;
  officeIds: number[] | null;
  departmentIds: number[] | null;
};

const today = new Date();

export const DEFAULT_FILTERS = {
  // First day of the current month
  fromDateIso: new Date(today.getFullYear(), today.getMonth(), 1).toISOString(),
  // Last day of the current month
  toDateIso: new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString(),
  states: ["PENDING", "APPROVED"],
  types: null,
  processed: null,
  officeIds: null,
  departmentIds: null,
} satisfies TimeEntryFilters;

interface TimeManagementState {
  search: string;
  currentFilters: TimeEntryFilters;
}

const initialState: TimeManagementState = {
  search: "",
  currentFilters: DEFAULT_FILTERS,
};

export type CSVRow = {
  name: string;
  from: string;
  to: string;
  type: string;
  comment: string;
  status: string;
};

export const timeManagementSlice = createSlice({
  name: "timeManagement",
  initialState,
  reducers: {
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setCurrentFilters: (state, action: PayloadAction<TimeEntryFilters>) => {
      state.currentFilters = action.payload;
    },
  },
});

export const {
  setSearch,
  setCurrentFilters,
} = timeManagementSlice.actions;

export const selectSearch = (state: RootState) => state.timeManagement.search;
export const selectCurrentFilters = (state: RootState) => state.timeManagement.currentFilters;

export default timeManagementSlice.reducer;
